/* The visual mobile drawer's panels (snippets/header-drawer-visual.liquid).
   Only loaded when the header's "Mobile menu style" is Visual.

   A top-level item with children opens its own panel, which slides in over the root; Back
   (or Escape) returns. Closing the drawer resets to the root, so it always reopens there.

   Craft's MenuDrawer (global.js) binds EVERY <button> inside header-drawer to
   onCloseButtonClick, which closes the nearest <details> -- and for these buttons that is the
   drawer itself. So clicks on our two controls are taken in the CAPTURE phase and stopped
   there, before they reach the button and Craft's listener. */
class DrawerPanels extends HTMLElement {
  connectedCallback() {
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));
    this.current = 'root';
    this.addEventListener('click', this.onClick, true);
    this.addEventListener('keyup', this.onKeyUp);
    this.drawer = this.closest('details');
    if (this.drawer) {
      this.drawer.addEventListener('toggle', () => {
        if (!this.drawer.open) this.show('root');
      });
    }
    this.show('root');
  }

  onClick = (event) => {
    const go = event.target.closest('[data-go]');
    const back = event.target.closest('[data-back]');
    if (!go && !back) return;
    event.preventDefault();
    event.stopPropagation();
    if (go) {
      this.opener = go;
      this.show(go.dataset.go, true);
    } else {
      this.show('root', true);
    }
  };

  /* Escape inside a panel steps back instead of closing the whole drawer. Stopped here, so
     header-drawer's own keyup (an ancestor) does not also see it. */
  onKeyUp = (event) => {
    if (!event.code || event.code.toUpperCase() !== 'ESCAPE' || this.current === 'root') return;
    event.stopPropagation();
    this.show('root', true);
  };

  show(id, moveFocus = false) {
    const next = this.panels.find((p) => p.dataset.panel === id) || this.panels[0];
    const from = this.current;
    this.current = next.dataset.panel;

    next.removeAttribute('inert');
    next.classList.add('is-active');
    next.classList.remove('is-under');
    next.scrollTop = 0;

    /* focus moves BEFORE the old panel goes inert: an inert panel drops focus to <body>, and
       a focusout that leaves the drawer is what Craft listens for to close it */
    if (moveFocus) {
      const target =
        this.current === 'root'
          ? (this.opener && this.opener.isConnected ? this.opener : next.querySelector(`[data-go="${from}"]`))
          : next.querySelector('[data-back]');
      if (target) target.focus({ preventScroll: true });
    }

    this.panels.forEach((panel) => {
      if (panel === next) return;
      panel.classList.remove('is-active');
      panel.classList.toggle('is-under', panel.dataset.panel === 'root');
      panel.setAttribute('inert', '');
    });
    this.querySelectorAll('[data-go]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.go === this.current)));
  }
}

if (!customElements.get('drawer-panels')) customElements.define('drawer-panels', DrawerPanels);
